import { render, staticRenderFns } from "./ItemDataRight.vue?vue&type=template&id=4a0e99f2&"
import script from "./ItemDataRight.vue?vue&type=script&lang=js&"
export * from "./ItemDataRight.vue?vue&type=script&lang=js&"
import style0 from "./ItemDataRight.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports